import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAssemblyType implements BaseEnumType {
  private static allValues: EnumAssemblyType[] = []; // make sure this is top-most
  
  public static materialProduction = new EnumAssemblyType(0, "MaterialProduction", "enum_assembly_type_material_production");
  public static productPackaging = new EnumAssemblyType(1, "ProductPackaging", "enum_assembly_type_product_packaging");
  public static maintenance = new EnumAssemblyType(2, "Maintenance", "enum_assembly_type_maintenance");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAssemblyType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isMaterialProduction() { return this === EnumAssemblyType.materialProduction; }
  public isProductPackaging() { return this === EnumAssemblyType.productPackaging; }
  public isMaintenance() { return this === EnumAssemblyType.maintenance; }

  public static getValues(): readonly EnumAssemblyType[] {
    return EnumAssemblyType.allValues;
  }

  public static getValuesExcept0(): readonly EnumAssemblyType[] {
    return EnumAssemblyType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAssemblyType {
    const found = EnumAssemblyType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAssemblyType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAssemblyType): EnumAssemblyType {
    const found = name ? EnumAssemblyType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAssemblyType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAssemblyType>): boolean {
    return this.key === other?.key;
  }
}